import InfoBarMessageViewStateCreator from 'owa-info-bar/lib/schema/InfoBarMessageViewStateCreator';
import WebExtNotificationTypeType from 'owa-service/lib/contract/WebExtNotificationTypeType';
import {
    ExtensibilityNotification,
    getExtensibilityNotification,
    lazyRemoveExtensibilityNotification,
    lazyUpdatePersistentNotifications,
} from 'owa-addins-core';
import {
    InfoBarCustomAction,
    InfoBarMessageColor,
    InfoBarMessageRank,
    InfoBarMessageSource,
    InfoBarMessageViewState,
} from 'owa-info-bar/lib/schema/InfoBarMessageViewState';
import strings from 'owa-strings/owa-extensibility-strings';

export default function createInfoBarMessageViewStateFactory(
    hostItemIndex: string,
    messageId: string,
    removeNotificationMessage: (messageId: string) => void
): InfoBarMessageViewStateCreator {
    return (): InfoBarMessageViewState => {
        const notification = getExtensibilityNotification(messageId);

        if (!notification) {
            return null;
        }

        const dismissAction = getDismissAction(
            hostItemIndex,
            messageId,
            notification,
            removeNotificationMessage
        );

        return <InfoBarMessageViewState>{
            key: notification.Key,
            source: InfoBarMessageSource.Extensibility,
            rank: getRank(notification.Type),
            messageParts: [notification.Message, '|', dismissAction],
            color: InfoBarMessageColor.Grey,
        };
    };
}

function getDismissAction(
    hostItemIndex: string,
    messageId: string,
    notification: ExtensibilityNotification,
    removeNotificationMessage: (messageId: string) => void
): InfoBarCustomAction {
    return <InfoBarCustomAction>{
        text: strings.dismissAddinsInfoBarLabel,
        action: () => {
            const extensionId = notification.ExtensionId;
            const isPersistent = notification.Persistent;

            lazyRemoveExtensibilityNotification.import().then(removeExtensibilityNotification => {
                removeExtensibilityNotification(messageId);

                if (isPersistent) {
                    lazyUpdatePersistentNotifications
                        .import()
                        .then(updatePersistentNotifications => {
                            updatePersistentNotifications(hostItemIndex, extensionId);
                        });
                }
            });
            removeNotificationMessage(messageId);
        },
    };
}

function getRank(type: WebExtNotificationTypeType): InfoBarMessageRank {
    switch (type) {
        case WebExtNotificationTypeType.InformationalMessage:
        case WebExtNotificationTypeType.ProgressIndicator:
            return InfoBarMessageRank.Info;
        case WebExtNotificationTypeType.ErrorMessage:
            return InfoBarMessageRank.Error;
    }
    return InfoBarMessageRank.Safety;
}
